import { PsoColor, PsoColorVar } from '@app/@wchfs-ui/lib/colors/colors.model';

export const toCssVariable = (color: PsoColor): PsoColorVar => {
  return `var(--${color})` as PsoColorVar;
};
